import { Flex } from '@/components/base';
import KeyboardNavigator from '@/components/KeyboardNavigator/KeyboardNavigator';
import type {
  KeyboardNavigatorKeymap,
  SelectedNavigatorItem,
} from '@/components/KeyboardNavigator/types';
import List from '@/components/List/List';
import Typo from '@/components/Typography/Typo';
import SearchQueryBuilderStyles from '@/features/GlobalSearch/components/SearchQueryBuilder/styles';

import {
  type NavigatorSelectItem,
  NavigatorTargetNameMap,
} from './types/navigatorTypes';

const { SelectListWrapperStyle, MatchedValueText, SectionTitleText } =
  SearchQueryBuilderStyles;

type Props = {
  selectedItem: SelectedNavigatorItem | null;
  setSelectedItem: (item: SelectedNavigatorItem | null) => void;
  keymap: KeyboardNavigatorKeymap | null;
  debouncedInput: string;
  data: NavigatorSelectItem[] | null;
  isLoading: boolean;
};

const DefaultNavigatorView = (props: Props) => {
  const {
    selectedItem,
    setSelectedItem,
    keymap,
    debouncedInput,
    data,
    isLoading,
  } = props;

  if (keymap === null || keymap.length === 0) return null;

  return (
    <SelectListWrapperStyle>
      <KeyboardNavigator.List f={3}>
        {!debouncedInput && <SectionTitleText>Recent history</SectionTitleText>}
        <List
          className="gap-0.5 flex-1 overflow-unset"
          data={data || []}
          isLoading={isLoading}
          render={(value, index) => {
            return (
              <KeyboardNavigator.Item
                key={`${value.target}.${value.alias}`}
                selected={
                  selectedItem?.col === 0 && selectedItem.index === index
                }
                onMouseEnter={() => {
                  setSelectedItem({
                    col: 0,
                    index,
                  });
                }}
                onClick={() => keymap[0]?.[index]?.action()}
              >
                <Flex a="center" g={8}>
                  {value.icon}
                  <MatchedValueText
                    matchedValue={debouncedInput}
                    text={value.name}
                  />
                  <MatchedValueText
                    matchedValue={debouncedInput}
                    text={value.path || ''}
                    dim
                  />
                  <Typo>- {NavigatorTargetNameMap.get(value.target)}</Typo>
                </Flex>
              </KeyboardNavigator.Item>
            );
          }}
        />
      </KeyboardNavigator.List>
    </SelectListWrapperStyle>
  );
};

export default DefaultNavigatorView;
